<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.users.dialogs.system_role.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ data.userName }} ({{ data.userEmail }})</p>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="system-role">
      <span class="av-meta">
        {{ 'backoffice.users.dialogs.system_role.role_label' | translate }}
      </span>
      <select id="system-role" class="av-field" formControlName="system_role">
        <option [value]="noneValue">
          {{ 'backoffice.enums.system_role.none' | translate }}
        </option>
        @for (role of roleOptions; track role) {
          <option [value]="role">{{ roleLabelKeys[role] | translate }}</option>
        }
      </select>
    </label>

    @if (data.isSelf) {
      <div class="av-banner p-3 d-flex align-items-start gap-2">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <span>{{ 'backoffice.users.dialogs.system_role.self_warning' | translate }}</span>
      </div>
    }

    @if (data.adminCount <= 1) {
      <label class="d-flex align-items-center gap-2">
        <input type="checkbox" formControlName="force" />
        <span class="av-section-hint">
          {{ 'backoffice.users.dialogs.system_role.force_label' | translate }}
        </span>
      </label>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.users.dialogs.system_role.confirm' | translate }}
  </button>
</mat-dialog-actions>
